<app-advanced-filter-pop-up (applyFilter)="onClickAdvancedFilter()" (clearFilter)="clearFields()">
    <form class="theme-form">
        <div class="modal-body mx-2 py-0">
            <div class="row mx-0">
                <div class="col-12 px-0 d-flex align-items-center mb-2">
                    <div class="w-135px f-14 font-semibold text-gray-color text-nowrap mb-0">
                        Branch
                    </div>
                    <div class="col">
                        <app-custom-select2 
                            #branchDropdown   
                            [customId]="'branchDropdown'"
                            [whichDropdown]="storageName?.BRANCH_DROPDOWN"
                            (valueChanged)="advanceFilterRequest.branchId = $event">
                        </app-custom-select2>
                    </div>
                </div>
                <div class="col-12 px-0 gap-3 d-flex align-items-center mb-2">
                    <div class="col d-flex align-items-center">
                        <div class="w-135px f-14 font-semibold text-gray-color text-nowrap mb-0">
                            Created
                        </div>
                        <div class="col">
                            <app-range-datepicker #orderDateComp [startDate]="advanceFilterRequest?.fromJoiningDate"
                                [endDate]="advanceFilterRequest?.toJoiningDate"
                                (startDateEmit)="advanceFilterRequest.fromJoiningDate = $event;"
                                (endDateEmit)="advanceFilterRequest.toJoiningDate = $event"></app-range-datepicker>
                        </div>
                    </div>
                    <div class="col d-flex align-items-center">
                        <div class="w-135px f-14 font-semibold text-gray-color text-nowrap mb-0">
                            Pickup Date
                        </div>
                        <div class="col">
                            <app-range-datepicker #dueDateComp [startDate]="advanceFilterRequest?.fromMaturityDate"
                                [endDate]="advanceFilterRequest?.toMaturityDate"
                                (startDateEmit)="advanceFilterRequest.fromMaturityDate = $event;"
                                (endDateEmit)="advanceFilterRequest.toMaturityDate = $event"></app-range-datepicker>
                        </div>
                    </div>
                </div>
                <div class="col-12 px-0 gap-3 d-flex align-items-center mb-2">
                    <div class="col px-0 gap-3 d-flex align-items-center">
                        <div class="col d-flex align-items-center">
                            <div class="w-135px f-14 font-semibold text-gray-color text-nowrap mb-0">
                                Next Payment
                            </div>
                            <div class="col">
                                <app-range-datepicker #orderDateComp [startDate]="advanceFilterRequest?.fromNextPaymentDate"
                                    [endDate]="advanceFilterRequest?.toNextPaymentDate"
                                    (startDateEmit)="advanceFilterRequest.fromNextPaymentDate = $event;"
                                    (endDateEmit)="advanceFilterRequest.toNextPaymentDate = $event"></app-range-datepicker>
                            </div>
                        </div>
                    </div>
                    <div class="col px-0 d-flex align-items-center">
                        <div class="w-135px f-14 font-semibold text-gray-color text-nowrap mb-0">
                            Status
                        </div>
                        <div class="col">
                            <app-select [options]="data.getAllDropdownModel?.layawaysStatusDropdown" [selectedValue]="advanceFilterRequest?.statusId"
                                (valueChanged)="advanceFilterRequest.statusId = $event" [id]="'statusId'" [name]="'statusId'">
                            </app-select>
                        </div>
                    </div>
                </div>
                <div class="col-12 px-0 d-flex align-items-center mb-2">
                    <div class="w-135px f-14 font-semibold text-gray-color text-nowrap mb-0">
                        Ledger
                    </div>
                    <div class="col">
                        <app-ng-multi-select-dropdown [isShowlable]="false" [isPlusIcon]="false" [name]="'accountledgerid'"
                            [getAllDropdownModel]="data.getAllDropdownModel?.accountLedgerDropdown"
                            [selectedIds]="selectedAccountledgerIds" [data]="data.getAllDropdownModel?.accountLedgerDropdown"
                            (onSelectItem)="advanceFilterRequest.selectedAccountledgerIds= $event"
                            [placeholder]="'Select Ledger'" [id]="'accountledgerid'">
                        </app-ng-multi-select-dropdown>
                    </div>
                </div>
                <div class="col-12 gap-3 px-0 d-flex align-items-center">
                    <div class="col px-0 d-flex align-items-center">
                        <div class="w-135px f-14 font-semibold text-gray-color text-nowrap mb-0">
                            Invoice No.
                        </div>
                        <div class="col">
                            <app-input [inputName]="'againstInvoiceNo'" [inputType]="'text'" [inputId]="'againstInvoiceNo'"
                                [isRequired]="false" [inputValue]="advanceFilterRequest?.againstInvoiceNo"
                                (inputValueEmit)="advanceFilterRequest.againstInvoiceNo = $event">
                            </app-input>
                        </div>
                    </div>
                    <div class="col px-0 d-flex align-items-center">
                        <div class="w-135px f-14 font-semibold text-gray-color text-nowrap mb-0">
                            Installment Fund No.
                        </div>
                        <div class="col">
                            <app-input [inputName]="'invoiceNo'" [inputType]="'text'" [inputId]="'invoiceNo'"
                                [isRequired]="false" [inputValue]="advanceFilterRequest?.invoiceNo"
                                (inputValueEmit)="advanceFilterRequest.invoiceNo = $event">
                            </app-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</app-advanced-filter-pop-up>